import { IconProps } from './IconProps';

export const CircleCheck = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_584_1503)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.442 0.519705C8.69424 0.632089 8.80762 0.927674 8.69523 1.17991C8.58285 1.43215 8.28726 1.54553 8.03502 1.43314C6.01238 0.531961 3.63786 1.06842 2.19916 2.75159C0.760468 4.43475 0.600297 6.86365 1.8055 8.72113C3.01071 10.5786 5.29422 11.4222 7.4177 10.7944C9.46794 10.1883 10.8974 8.34986 10.9947 6.23113L11 6.00309V5.49712C11 5.22098 11.2239 4.99712 11.5 4.99712C11.7455 4.99712 11.9496 5.174 11.9919 5.40725L12 5.49712V6.00338C11.9985 8.66044 10.2494 11 7.70122 11.7534C5.15307 12.5067 2.41287 11.4944 0.966612 9.26543C-0.479659 7.03641 -0.287449 4.12167 1.439 2.10185C3.16545 0.0820379 6.01484 -0.561705 8.442 0.519705ZM11.7801 1.1728C12.0465 1.43895 12.0709 1.8556 11.8531 2.14931L11.7806 2.23346L6.28058 7.7386C6.01435 8.00507 5.59754 8.0294 5.30383 7.8115L5.21969 7.73886L3.56969 6.08897C3.27679 5.79609 3.27677 5.32122 3.56966 5.02831C3.83591 4.76204 4.25258 4.73782 4.5462 4.95566L4.63032 5.02828L5.749 6.14703L10.7194 1.1733C11.0122 0.88027 11.487 0.880047 11.7801 1.1728Z"
          fill={props.fill ?? '#ffffff'}
        />
      </g>
      <defs>
        <clipPath id="clip0_584_1503">
          <rect width="12" height="12.0001" fill={props.fill ?? '#ffffff'} />
        </clipPath>
      </defs>
    </svg>
  );
};

